<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      unit="图片"
      edit-title
      id-key="UserId"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      :line-form="true"
      form-label-width="100px"
      @close-saved="$emit('close-saved')"
      label-position="left"
      :confirm-on-close-change="false"      
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="图片" class="notBottom" prop="Imgs">
              <div>
                <el-upload
                  class="file-up"
                  :action="host + '/api/Common/UploadPicture'"
                  list-type="picture-card"
                  :show-file-list="true"
                  accept=".jpg,.png,"
                  :on-success="
                    (res, file, fileList) => {
                      onSuccess(res, file, fileList, 'Imgs')
                    }
                  "
                  :headers="headers"
                  :file-list="Imgs"
                  :limit="10"
                  :on-preview="handlePictureCardPreview"
                  :on-exceed="onExceed"
                  :before-upload="beforePhotoUpload"
                  :on-remove="
                    (file, fileList) => {
                      fileRemove(file, fileList, 'Imgs')
                    }
                  "
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!-- <el-tooltip class="upload-tip" effect="light" content="图片格式须为jpg、png, 可上传多图" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip> -->
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="saved">确定</el-button>
      </template>
    </common-dialog>
    <el-dialog :visible.sync="dialogVisible" title="查看图片" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import * as imageConversion from 'image-conversion'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      Imgs: [],
      removeImgs: [],
      data: { TeImgs: [] },
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } //传图片时加上token
    }
  },
  computed: {
    host() {
      return window.location.origin
    }
  },
  methods: {
    onCreateOpened(data){
      console.log(data, 'data')
       this.Imgs = []
      if (data.TeImgs.length > 0) {
        data.TeImgs.forEach(item => {
          this.Imgs.push({ url: '/api' + item.ImgUrl, url2: item.ImgUrl, T: 0, TeProductId: item.TeProductId, ProductImgId: item.ProductImgId })
        })
      }
    },
    onEditOpened(data) {
      this.Imgs = []
      console.log(data, 'data')
      if (data.TeImgs.length > 0) {
        data.TeImgs.forEach(item => {
          this.Imgs.push({ url: '/api' + item.ImgUrl, url2: item.ImgUrl, T: 3, TeProductId: item.TeProductId, ProductImgId: item.ProductImgId })
        })
      }
    },
    beforePhotoUpload(file) {
      //const is500k = file.size / 1024 <= 2048;
      // if (!is500k) {
      //   this.$message.error("照片大小不能超过2M");
      // }
      // return is500k;
      var limit = 5
      return new Promise((resolve, reject) => {
        let fileTypeLength = file.name.split('.').length
        if (fileTypeLength > 0) {
          let fileType = file.name.split('.')[fileTypeLength - 1].toLowerCase()
          const extension = fileType === 'jpg'
          const extension2 = fileType === 'png'
          const extension4 = fileType === 'jpeg'
          const isSizeBig = file.size / 1024 / 1024 < limit // 图片大小不超过1M
          if (!extension && !extension2 && !extension4) {
            this.$message.warning(this.salewaynumber == 'en' ? 'Pictures can only be in jpg,jpeg,png format' : '上传图片只能是 JPG、JPEG、PNG 格式!')
            //this.isUpload = false;
            reject(false)
          } else {
            // resolve(file)
            if (isSizeBig) {
              resolve(file)
            } else {
              // this.$message.warning(
              //   `当前图片为${(file.size / 1024 / 1024).toFixed(2)}M，将进行压缩`
              // );
              imageConversion.compressAccurately(file, 1024).then(res => {
                // console.log(res, "aa");
                // this.$message.warning(
                //   `压缩完成大小约为${(res.size / 1024 / 1024).toFixed(2)}M`
                // );
                resolve(res)
              })
            }
          }
        }
      })
    },
    onSuccess(res, file, fileList, name) {
      if (res.Code == 0) {
        this[name].push({ url: '/api' + res.Data, url2: res.Data, T: 0 })
      } else {
        fileList.splice(fileList.length - 1, 1)
        this.$message.error(res.Msg)
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    fileRemove(file, fileList, name) {
      console.log(file, 'move')
      var index = this[name].findIndex(x => x.url == file.url)
      if (index > -1) {
        if (file.T == 0) {
          this[name].splice(index, 1)
        } else {
          this.removeImgs.push(this[name].splice(index, 1)[0])
        }
      }
    },
    onExceed() {
      this.$message.error('超过上传数量限制')
    },
    saved() {
      this.$emit('saved', this.Imgs, this.removeImgs)
      this.Imgs = []
      this.close()
    },
    onClosed(){
      this.Imgs = []
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}
</style>